import React from 'react';
import sidekick from '@last-rev/contentful-sidekick-util';
import PropTypes from 'prop-types';
import cx from 'clsx';
import styles from './ModuleHero.module.scss';
import Asset from '../Asset';
import AssetPropTypes from '../Asset/AssetPropTypes';
import { ElementLinkPropTypes } from '../ElementLink';
import { useRouter } from 'next/router';

import ReactMarkdown from 'react-markdown';

export const ModuleHeroPropTypes = {
  _id: PropTypes.string.isRequired,
  _contentTypeId: PropTypes.string.isRequired,
  headerText: PropTypes.string.isRequired,
  summaryText: PropTypes.string,
  image: PropTypes.shape(AssetPropTypes),
  cta: PropTypes.shape(ElementLinkPropTypes),
  className: PropTypes.string
};

function ModuleHero({ _id, _contentTypeId, headerText, summaryText, image, className, slug }) {
  const router = useRouter()
  const coursePagerouter = router.asPath.includes("self-guided-learning") ||
    router.asPath.includes("video-library") || router.asPath.includes("profile") || router.asPath.includes("nonprofit-courses")
  return (
    <section
      {...sidekick(_id, null, _contentTypeId, 'Module Hero')}
      data-testid="ModuleHero"
      className={cx(className, styles.moduleHero, 'themeBgColor')}
      contenttype="moduleHero">
      <div className={styles.moduleContainerWrap}>
        <div className={`${coursePagerouter ? styles.coursePage : ''} ${styles.moduleContainerRow}`}>
          <div className={styles.textCol}>
            <div className={styles.headerTextWrap} {...sidekick(_id, 'headerText', _contentTypeId)}>
              <h1 className={styles.headerText} data-testid="ModuleHero-headerText">
                {headerText}
              </h1>
            </div>

            {summaryText ? (
              <div className={styles.summaryTextWrap} {...sidekick(_id, 'summaryText', _contentTypeId)}>
                {slug === "nonprofit-courses"?
                  <ReactMarkdown className={styles.summaryTextnew}>{summaryText}</ReactMarkdown> :
                  <p className={styles.summaryText} data-testid="ModuleHero-summaryText">
                    {summaryText}
                  </p>
                }
              </div>
            ) : null}
          </div>


        </div>
      </div>
    </section>
  );
}
ModuleHero.propTypes = ModuleHeroPropTypes;
ModuleHero.defaultProps = {
  summaryText: null,
  image: null,
  cta: null,
  className: 'theme-default'
};

export default ModuleHero;